import React from "react";

import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

import useStyles from "./styles";

const shareIcon = require("Assets/img/share-icon.svg");

const renderSharedReference = (
  reference: string,
  condition: boolean,
  resource: string,
  sharedWordTooltip = true
) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  if (!condition) return reference;

  const tooltip = sharedWordTooltip ? `${translate("shared")} ${resource}` : resource;

  return (
    <div className={classes.row}>
      <span>{reference}</span>
      <Tooltip title={tooltip ?? ""} placement="top">
        <div>
          <img src={shareIcon} />
        </div>
      </Tooltip>
    </div>
  );
};

export default renderSharedReference;
